import { Injectable } from '@angular/core';
import {BaseService} from '@core/service/base.service';
import {UrlConstant} from '@shared/constants/url.constant';
import {EditUserRequest, FilterUserRequest} from '@modules/administration/users/interfaces/user.request';
import {FilterOrderRequest} from "@modules/administration/orders/interfaces/order.request";
import {OrderModel} from "@modules/administration/orders/interfaces/order.model";
import {FilterReportRequest} from "@modules/administration/report/interfaces/report.request";

@Injectable()
export class ReportService extends BaseService{
  readonly prefixUrl =  UrlConstant.REPORT.PREFIX;
  public summaryOrder(filter: FilterReportRequest) {
    return this.post(this.prefixUrl + UrlConstant.REPORT.SUMMARY_ORDER, filter);
  }
}
